export var DrawRecordTypes;
(function (DrawRecordTypes) {
    DrawRecordTypes["arcWithOrigin"] = "A";
    DrawRecordTypes["arcWithMidpoint"] = "AM";
    DrawRecordTypes["arcForSVG"] = "AS";
    DrawRecordTypes["circle"] = "C";
    DrawRecordTypes["polyline"] = "P";
    DrawRecordTypes["rectangle"] = "S";
    DrawRecordTypes["text"] = "T";
    DrawRecordTypes["pin"] = "X";
    DrawRecordTypes["polygon"] = "G";
    DrawRecordTypes["curve"] = "V";
    // Only supported in .kicad_sym files
    DrawRecordTypes["bezierCurve"] = "B";
})(DrawRecordTypes || (DrawRecordTypes = {}));
export var PinDirection;
(function (PinDirection) {
    PinDirection["left"] = "L";
    PinDirection["right"] = "R";
    PinDirection["up"] = "U";
    PinDirection["down"] = "D";
})(PinDirection || (PinDirection = {}));
//# sourceMappingURL=schematicModels.js.map